import { HomeApiDataSource } from "../data/datasources/HomeApiDataSource";
import { HomeRepositoryImpl } from "../data/repositories/HomeRepositoryImpl";
import { GetHomeSummaryUseCase } from "../domain/usecases/GetHomeSummaryUseCase";

/**
 * Wiring for the home feature.
 *
 * Mirrors `features/reco/di/container.ts`: singletons built once at module load,
 * use cases exposed as factories so hooks can keep stable references.
 */
class HomeContainer {
  private readonly dataSource = new HomeApiDataSource();
  private readonly repository = new HomeRepositoryImpl(this.dataSource);
  private readonly getHomeSummaryUseCase = new GetHomeSummaryUseCase(this.repository);

  getHomeSummary(): GetHomeSummaryUseCase {
    return this.getHomeSummaryUseCase;
  }
}

export const homeContainer = new HomeContainer();
